<div class="info-block-container">
  <p class="info-title">{{ title() | translate }}</p>
  <p class="info-text">{{ text() ?? '' | translate }}</p>
</div>
